import React, { useEffect, useState } from "react";
import { Facebook, Instagram, Mail, PhoneCall, MapPinHouse } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../Assets/Logos/CovenantLogo.png";
import { FiHeart } from "react-icons/fi";
import axios from "axios";
import { toast } from "react-toastify";


const navLinks = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Projects", to: "/projects" },
  { label: "Blog", to: "/blogs" },
  { label: "Contact Us", to: "/contact" },
];

const UserFooter = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [email, setEmail] = useState("");

  const handleSubscribe = async () => {
    try {
      const payload = {
        email,
        name: "Anonymous",
        message: "Subscribe me to your newsletter!!!",
        phone: "0000000000",
        status: "justConnection",
      };
      await axios.post(`${process.env.REACT_APP_API_URL}/inquiry/create-inquiry`, payload);
      toast.success("Subscribed successfully!");
      setEmail("");
    } catch (err) {
      console.error("Failed to subscribe", err);
      toast.error("Failed to subscribe");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="bg-[#020316] mt-6 lg:mt-40">
      {/* Hero Call-to-Action Section */}
      <div className="relative w-full flex justify-center">
        <div className="absolute -top-40 sm:-top-14 lg:-top-40 w-[90%] max-w-7xl bg-[#FF5A3C] px-6 py-8 sm:py-12 lg:py-14 rounded-md shadow-xl z-10">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 lg:gap-10">
            <div className="text-white">
              <h1 className="text-md sm:text-3xl lg:text-4xl font-bold mb-2 sm:mb-4">
                Looking For a Dream Home?
              </h1>
              <p className="text-xs sm:text-base lg:text-lg opacity-90">
                We Help You Make The Dream Of A New House A Reality
              </p>
            </div>
            <div className="w-full lg:w-auto">
              <button
                onClick={() => {
                  navigate("/projects");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                className="w-full sm:w-auto bg-white text-[#FF5A3C] px-6 py-3 rounded font-semibold hover:bg-gray-100 transition-colors"
              >
                Explore Now →
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Navigation Bar */}
      <nav className="bg-[#020316] border-b border-gray-700 -mt-8 sm:-mt-12 lg:-mt-16 pt-8 sm:pt-12 lg:pt-28">
        <div className="max-w-7xl mx-auto ">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between py-4 gap-4 sm:gap-0">
            {/* Logo + Name */}
            <div className="flex items-center gap-4">
              <img src={Logo} alt="Logo" className="h-16" />
            </div>

            {/* Navigation Links */}
            <div className="flex flex-wrap gap-4 sm:gap-6 lg:gap-8 text-sm sm:text-base font-medium">
              {navLinks.map(({ label, to }) => (
                <Link
                  key={label}
                  to={to}
                  className={`${
                    label === "Home" ? "text-white" : "text-gray-300"
                  } hover:text-[#FF5A3C] transition-colors`}
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </nav>

      {/* Footer Content */}
      <div className="bg-[#020316] py-10 px-4 sm:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* About Us */}
          <div>
            <h3 className="text-white font-semibold mb-4">About Us</h3>
            <ul className="space-y-2 text-sm">
              {[
                "About Company",
                "Company History",
                "Management & Promoters",
                "Our Vision",
                "Awards",
              ].map((item, i) => (
                <li key={i}>
                  <a
                    href="#"
                    className="text-gray-300 hover:text-[#FF5A3C] transition-colors"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
            {/* Social Media */}
            <div className="flex space-x-3 mt-6">
              <a
                href="https://www.facebook.com/share/1E483T5gBW/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-[#FF5A3C] rounded flex items-center justify-center hover:bg-red-600 transition-colors"
              >
                <Facebook size={20} className="text-[#020316]" />
              </a>
              <a
                href="https://www.instagram.com/covenantsdevelopers?igsh=MTI5emdlOHNzdjlpdg=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 bg-[#FF5A3C] rounded flex items-center justify-center hover:bg-red-600 transition-colors"
              >
                <Instagram size={20} className="text-[#020316]" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="flex flex-col space-y-2 text-sm">
              {navLinks.map(({ label, to }) => (
                <Link
                  key={label}
                  to={to}
                  className={`${
                    label === "Home" ? "text-white" : "text-gray-300"
                  } hover:text-[#FF5A3C] transition-colors`}
                >
                  {label}
                </Link>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm text-gray-300">
              <li className="flex items-start gap-2">
                <PhoneCall className="text-[#FF5A3C] w-4 h-4 mt-1" />
                <span>7737373307, 6372664851</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="text-[#FF5A3C] w-4 h-4 mt-1" />
                <span>covenantsdevelopers@gmail.com</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPinHouse className="text-[#FF5A3C] w-10 h-10 mt-1" />
                <span>K7-29, Kalinga Nagar, Ghatikia, Bhubaneswar-751003</span>
              </li>
            </ul>
          </div>
          {/* Newsletter */}
          <div>
            <h3 className="text-white font-semibold mb-4">Newsletter</h3>
            <p className="text-gray-300 text-sm mb-4">
              Subscribe to our Newsletter to get updates on our projects and
              offers.
            </p>
            <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-2">
              <input
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 px-3 py-2 bg-gray-800 text-white text-sm border border-gray-600 rounded focus:outline-none focus:border-[#FF5A3C]"
              />
              <button
                onClick={handleSubscribe}
                className="bg-[#FF5A3C] text-white px-4 py-2 text-sm rounded hover:bg-red-600 transition-colors"
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bg-[#020316] border-t border-gray-700 px-4 sm:px-6 lg:px-10 py-4">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-2 text-xs sm:text-sm text-gray-400">
          <div>© 2025 Covenants Developers Pvt. Ltd. All Rights Reserved</div>
          <div className="text-center sm:text-right">
            Made with{" "}
            <FiHeart size={15} className="inline-block text-[#FF5A3C]" /> by -{" "}
            <a
              className="text-[#FF5A3C]"
              href="https://www.webbocket.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Web_Bocket
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFooter;
